import api, { APIURL, errorHandle, authenHeader } from '../api/api'

class User {
    constructor(data) {
        this.id = data.id
        this.title = data.title
        if (typeof (this.title) === "string") {
            this.title_select = {
                "label": this.title,
                "value": this.title
            }
        }
        this.first_name = data.first_name
        this.last_name = data.last_name
        this.full_name = data.full_name
        this.id_card = data.id_card
        this.username = data.username
        this.position = data.position
        this.level_id = data.level_id
        this.level_name = data.level_name
        this.level_select = {
            "label": this.level_name,
            "value": this.level_id
        }

        this.office_code = data.office_code
        this.office_name = data.office_name
        this.office_select = {
            "label": this.office_name,
            "value": this.office_code
        }

        this.tel = data.tel
        this.email = data.email
        this.role_id = data.role_id
        this.role_name = data.role_name
        this.status = data.status

        this.token = data.token
        this.authorized = data.authorized

        // select ...
        if (data.office) this.office = data.office
        if (data.level) this.level = data.level
        if (data.role) this.role = data.role

        // create_at
        this.created_at = data.created_at
    }

    formData() {
        return {
            title: this.title_select,
            level: this.level_select,
            office: this.office_select,
            first_name: this.first_name,
            last_name: this.last_name,
            id_card: this.id_card,
            tel: this.tel,
            email: this.email,
            position: this.position,
        }
    }

    serialized() {
        const idCardText = this.id_card?.replace(/ +/g, '')
        const telText = this.tel?.replace(/ +/g, '')
        return {
            "username": this.username || '',
            "title": this.title?.value,
            "first_name": this.first_name,
            "last_name": this.last_name,
            "id_card": idCardText,
            "position": this.position,
            "level_id": parseInt(this.level?.value) || 0,
            "office_code": this.office?.value,
            "tel": telText,
            "email": this.email,
            "status": this.status || '',
            "role_id": parseInt(this.role?.value) || 0
        }
    }

    isAcceptRoles(roles) {
        return roles.includes(this.role_id)
    }
}

export const getAllUsers = (query, token) => {
    const headers = {
        headers: authenHeader(token)
    }

    return new Promise((resolve, reject) => {
        api.get(APIURL.USER(query), headers)
            .then(response => {
                if (response.data.data) {
                    const list = response.data.data.map(d => new User(d))
                    resolve(list)
                } else {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export const getUserInfo = (uid, token) => {
    const headers = {
        headers: authenHeader(token)
    }

    return new Promise((resolve, reject) => {
        api.get(APIURL.USER(uid), headers)
            .then(response => {
                if (response.data.data) {
                    const userData = new User(response.data.data)
                    resolve(userData)
                } else {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export const addNewUser = (data, token) => {
    const headers = {
        headers: authenHeader(token)
    }

    return new Promise((resolve, reject) => {
        api.post(APIURL.USER(), data, headers)
            .then(response => {
                if (response.data.data) {
                    const userData = new User(response.data.data)
                    resolve(userData)
                } else {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export const putUpdateUserInfo = (uid, data, token) => {
    const headers = {
        headers: authenHeader(token)
    }

    return new Promise((resolve, reject) => {
        api.put(APIURL.USER(uid), data, headers)
            .then(response => {
                if (response.data.data) {
                    const userData = new User(response.data.data)
                    resolve(userData)
                } else {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}


export default User